export const CyFilterCard = {
  TonalityFilter: "FilterCard-Tonality",
  LanguageFilter: "FilterCard-Language",
  TagsFilter: "FilterCard-Tags",
} as const;
